/* unplugin-vue-components disabled */import { render } from "./Orders.vue?vue&type=template&id=56c02a2a&ts=true"
import script from "./Orders.vue?vue&type=script&lang=ts"
export * from "./Orders.vue?vue&type=script&lang=ts"

import "./Orders.vue?vue&type=style&index=0&id=56c02a2a&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__